import React from 'react';
import { Link } from 'react-router-dom';
import './CommonDropdown.css';

export const CommonDropdown = ({ children, isVisible, align = "right", style }) => {
  return (
    <div 
      className={`common-dropdown-container ${isVisible ? 'visible' : ''} align-${align}`} 
      style={style}
    >
      <div className={`common-dropdown-arrow arrow-${align}`} />
      <div className="common-dropdown-content">
        {children}
      </div>
    </div>
  );
};

export const CommonDropdownItem = ({ icon, title, subtitle, onClick, to }) => {
  const content = (
    <>
      <div className="common-dropdown-icon">
        {icon}
      </div>
      <div className="common-dropdown-text">
        <div className="common-dropdown-title">{title}</div>
        {subtitle && <div className="common-dropdown-subtitle">{subtitle}</div>}
      </div>
    </>
  );

  if (to) {
    return <Link to={to} className="common-dropdown-item">{content}</Link>;
  }

  return (
    <div className="common-dropdown-item" onClick={onClick}>
      {content}
    </div>
  );
};
